export default {
    opinion: "审批意见",
    attachment: "附件",
    image: "图片",
    total: "合计",
    copy: "复制",
    delete: "删除",
    selectNumber: "选择序列",
    inputAddress: "请输入详细地址",
    cancel: "取消",
    clear: "清除",
    ok: "确定",
    reset: "重置",
    addSign: "添加手写签名",
    sign: "手写签名",
    addition: "请添加",
    expand: "展开",
    collapse: "收起",
    peleseSelect: "请选择",
    peleseInput: "请输入",
    city: "市",
    countyArea: "县/区",
    filter: "筛选",
    search: "搜索",
    back: "返回",
    number: "序号",
    indexOf: "第{index}行",
    searching: "搜索中…",
    searchResultTip: "搜索结果：共{total}条",
    searchNoResultTip: "未找到“{text}”相关结果",
    noMore: "已加载全部数据",
    noOptions: "暂无选项",
    noData: "没有数据",
    frozenColumn: "冻结此列",
    unFrozenColumn: "取消冻结",
    checkAll: "全选",
    clickUpload: "点击上传",
    action: "操作",
    downloadAll: "批量下载",
    exportFile: "导出文件",
    importFile: "导入模板",
    label: {
        creater: "创建人：",
        createTime: "创建时间：",
        formStatus: "表单状态：",
        sum: "求和：",
        avg: "平均值：",
        min: "最小值：",
        max: "最大值："
    },
    formStatus: {
        draft: "草稿",
        processing: "进行中",
        completed: "已完成",
        canceled: "已作废"
    },
    sheet: {
        clearRow: "清空行",
        addBefore: "在上面添加行",
        addAfter: "在下面添加行",
        logicFalseValue: "否",
        logicTrueValue: "是"
    },
    tip: {
        clickPosition: "点击定位",
        onlySupportMobileWrite: "仅支持移动端填写",
        clickAndDropUpload: "点击或拖拽上传",
        position: "PC端可能会出现定位偏差，可前往移动端精确定位",
        frozenColumnMax: "最多冻结3列，请先取消冻结列",
        frozenColumnWidthMax: "冻结列总宽度已超过表单宽度，请重新设置列宽",
        previewError: "文件类型不支持，请在PC查看",
        importErrorRelation: "表单关联了流程实例",
        importErrorEmpty: "模板为空，请填写信息",
        importError: "模板不正确，请检查",
        uploadError: '上传失败请重试',
        overSize: '文件最大可上传{label}MB',
        fileNameCheck: '附件名称不能包含特殊符号: ","',
        imageNameCHeck: '图片名称不能包含特殊符号: ","',
        imageSuport: `图片格式错误,只支持{label}`,
        fileSuport: '文件格式错误,只支持{label}文件',
        fileUnsuport: '文件格式错误,不支持{label}文件'
    },
    errorCode: {
        min: "{label}不能小于最小值",
        max: "{label}不能大于最大值",
        minCount: "{label}数量不能小于{num}张",
        maxCount: "{label}数量不能大于{num}张",
        input: "请输入{label}",
        select: "请选择{label}",
    }
};
